import TagBox from "devextreme-react/tag-box";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useCommonContext } from "../../contexts/common";
import { sf_hinhthucmiengiam } from "../../models/response/category/sf_hinhthucmiengiam";
import { RootState } from "../../state/reducers";
type ITagBoxHinhThucMienGiamProps = {
    nhom_mien_giam: number,
    isReadonly?: boolean,
    value?: number[],
    width?: number,
    onValueChanged: (id: number[], data?: any[]) => void,
    className?: string,
    isShowClearButton?: boolean,
    preText?: string,
    stylingMode?: "outlined" | "filled" | "underlined"
    dataSource?: sf_hinhthucmiengiam[]
}
const TagBoxHinhThucMienGiam = (props: ITagBoxHinhThucMienGiamProps) => {
    const { nam_hoc, dm_coso_id } = useSelector((x: RootState) => x.common)
    const { translate } = useCommonContext();
    const dataSource = useMemo(() => {
        if (props.nhom_mien_giam === undefined || props.nhom_mien_giam === null || props.nhom_mien_giam === 0) return [];
        return props.dataSource?.filter(x => x.nam_hoc === nam_hoc && x.nhom_mien_giam === props.nhom_mien_giam)
    }, [props.nhom_mien_giam, dm_coso_id, nam_hoc])
    return (
        <TagBox dataSource={dataSource}
            displayExpr={"ma_hinh_thuc"}
            valueExpr={"id"}
            value={props.value}
            stylingMode={props.stylingMode || "outlined"}
            readOnly={props.isReadonly === true}
            placeholder={translate("Chọn hình thức")}
            width={200}
            className={"default_selectbox " + (props.className ? props.className : "")}
            showClearButton={props.isShowClearButton === true}
            searchEnabled={true}
            showSelectionControls={true}
            height={34}
            maxDisplayedTags={4}
            dropDownOptions={{
                width: 'auto', 
                minWidth: 300, 
                maxWidth: 500, 
            }}
            onValueChanged={(e) => {
                if (e.event) {
                    if (e.value) {
                        const data = props.dataSource?.filter(x => e.value.includes(x.id))
                        props.onValueChanged(e.value, data)
                    } else {
                        props.onValueChanged([], [])
                    }
                }
            }} />
    );
}
export default TagBoxHinhThucMienGiam;